<div class="users-page">
    <mat-card appearance="outlined" class="page-header">
        <div class="header-row">
            <div>
                <h2>Users</h2>
                <p class="page-description">Every LINQ user account, across all organisations.</p>
            </div>
            <button mat-stroked-button color="accent" (click)="exportUsers()" [disabled]="!users?.length">
                <mat-icon>download</mat-icon>Export to CSV
            </button>
        </div>
        @if (users) {
            <div class="summary">
                @for (s of summary; track s.label) {
                    <div class="stat" [matTooltip]="s.hint">
                        <div class="stat-value">{{s.value}}</div>
                        <div class="stat-label">{{s.label}}</div>
                    </div>
                }
            </div>
        }
    </mat-card>

    @if (users) {
        <app-onboarding-funnel [users]="users"></app-onboarding-funnel>
    }

    <mat-card appearance="outlined">
        <mat-card-content>
            @if (loading && !users) {
                <div class="loading"><mat-spinner diameter="32"></mat-spinner><span>Loading users&hellip;</span></div>
            }@else {
                <app-table [columns]="columns" [data]="data" [filter]="true" [height]="getTableHeight()" (rowEvent)="handleRowEvent($event)"></app-table>
            }
        </mat-card-content>
    </mat-card>
</div>
